module.exports = __webpack_public_path__ + "img/img_inner_chess.aac28260.png";